$(document).ready(function() {
  jQuery('.vertical-menu').find('.vertical-li').each(function(){
    if($(this).find('.vertical-column').children().length > 32) {
      $(this).find('.vertical-column').addClass('threeColumns').css({'width':'550px','columns':'3','-webkit-columns':'3','-moz-columns':'3'});
      
    }else if($(this).find('.vertical-column').children().length > 16){
      $(this).find('.vertical-column').addClass('twoColumns').css({'width':'450','columns':'2','-webkit-columns':'2','-moz-columns':'2'});
    }
  });
});

$(document).ready(function() {
    $('#ajax-searchbar').keyup(function() {
        $('#result-ajax-search').show();
        $("#loadinggif").show();
        $(".result-item").remove();
        if (event.keyCode == 8 || event.keyCode == 46) {
            $(".result-item").remove();
            $('.data_not_found').hide();
            document.getElementById('startloc').value = 0;
            document.getElementById('endloc').value = 30;
        }
        $('.errmsg').hide();
        var prodname = $('#ajax-searchbar').val();
        setTimeout(function() { 
            if($('#ajax-searchbar').val() == prodname){ // Check the value searched is the latest one or not. This will help in making the ajax call work when client stops writing.
                if(prodname.length > 2){
                    document.getElementById('prodname').value = prodname;
                    getProductData();
                }
                else{
                    $("#loadinggif").hide(); 
                    $(".result-item").remove();
                    $("#result-ajax-search").show();
                    $('.errmsg').show();
                    $('.data_not_found').hide();
                    document.getElementById('startloc').value = 0;
                    document.getElementById('endloc').value = 30;
                }
            }
        }, 700);
    });
});
function getProductData(){       
    prodname = document.getElementById('prodname').value;
    start = document.getElementById('startloc').value;
    limit = document.getElementById('endloc').value;
    var timer;
    if(start == 0){ $(".result-item").remove(); }
    $.ajax({
        url:"/apps/product-search-2/"+"?searchbar="+prodname+"&start="+start+"&limit="+limit,
        method: 'GET',
        data: JSON.stringify({searchbar:prodname,start:start,limit:limit}),
        crossDomain: true,
        success:function(data)
        {
            $("#loadinggif").hide(); 
            $('#result-ajax-search').show();
            $('.errmsg').hide();
            $('.searchh-results').append(data);
            if(data.length == 0){
                $('.data_not_found').show();
            }else{
                $('.data_not_found').hide();
            }
        }
    });
}
$('.searchh-results').on('scroll', function() {
    if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
        var getStart = document.getElementById('startloc').value;
        var start = parseInt(getStart) + 10;
        document.getElementById('startloc').value = start;
        getProductData();
    }
});
$(document).click(function(e){
    var container = $("#result-ajax-search");
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        container.hide();
        $(".result-item").remove();
    }
}); 

$(document).ready(function() {
    $('#ajax-searchbar-sku').keyup(function() {
        // console.log(document.getElementById("ajax-searchbar-sku").value);
        $('#result-ajax-search-sku').show();
        $("#loadinggif-sku").show();
        var prodnamesku = $('#ajax-searchbar-sku').val();
        // console.log(prodnamesku);
        setTimeout(function() {
            if($('#ajax-searchbar-sku').val() == prodnamesku){ // Check the value searched is the latest one or not. This will help in making the ajax call work when client stops writing.
                if(prodnamesku.length >= 2){
                    document.getElementById('ajax-searchbar-sku').value = prodnamesku;
                    getProductDataSKU();
                }
                else{
                    $("#loadinggif-sku").hide(); 
                    $(".result-item").remove();
                    $("#result-ajax-search-sku").show();
                    $('.errmsg-sku').show();
                    $('.data_not_found-sku').hide();
                }
            }
        }, 700);
    });
    var p = document.getElementsByTagName('p');
    Array.prototype.forEach.call(p, function(el) {
        el.innerHTML = el.innerHTML.replace(/&nbsp;/gi, ' ');
    });
});
function getProductDataSKU(){
    prodname = document.getElementById('ajax-searchbar-sku').value;
    // console.log(prodname);
    start = document.getElementById('startlocn').value;
    limit = document.getElementById('endlocn').value;
    var timer;
    if(start == 0){ $(".result-item").remove(); }
    $.ajax({
        url:"/apps/product-search-2/"+"?skusearch="+prodname+"&start="+start+"&limit="+limit,
        method: 'GET',
        data: JSON.stringify({skusearch:prodname,start:start,limit:limit}),
        crossDomain: true,
        success:function(data)
        {
            $("#loadinggif-sku").hide(); 
            $('#result-ajax-search-sku').show();
            $('.errmsg-sku').hide();
            $('.searchh-results-sku').append(data);
            if(data.length == 0){
                $('.data_not_found-sku').show();
            }else{
                $('.data_not_found-sku').hide();
            }
        }
    });
}
/*var link = document.getElementById("product_link").value;
var prodsku = document.getElementById("product_sku").value;
$('head').find('link').each(function () {
    if($(this).attr('hreflang')== 'en-us'){
        // console.log("Found it");
        document.getElementById("link_present").value = '1';
    }
});*/
// $(document).ready(function() {
//     window.onscroll = function() {
//         var nav = document.getElementsByClassName('nav-mobile-menu');
//         if ( window.pageYOffset > 200 ) {
//             $('.rhinox-menu').addClass('navscrolld');
//             console.log("Hello I am from scrolling from webcast-js");
//         } else {
//             $('.rhinox-menu').removeClass('navscrolld');
//         }
//         var screenwidth = $(window).width();
//         if(screenwidth <= 500){
//             if ( window.pageYOffset > 750 ) {
//                 $('.top-cart-row').addClass('navscroll');
//             }
//             else{
//                 $('.top-cart-row').removeClass('navscroll');
//             }
//         }
//     }
// });